import { FormGroup, Input, Select } from '@agro-club/agroclub-shared'
import { FormikFieldsType } from 'modules/domain/types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const OneLineControls = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 168px 120px;
`

type Props = {
  formik: FormikFieldsType
}
export const FormStorageControl = ({ formik }: Props) => {
  const { t } = useTranslation('warehouses')
  const unitsOptions = useMemo(() => {
    return [
      {
        label: t('storage_costs_units.per_day'),
        value: 'per_day',
      },
      {
        label: t('storage_costs_units.per_month'),
        value: 'per_month',
      },
    ]
  }, [t])
  return (
    <FormGroup label={t('elevator_costs_short.storage_costs')} error={formik.errors.storage_costs}>
      <OneLineControls>
        <Input {...formik.getFieldProps('storage_costs')} invalid={!!formik.errors.storage_costs} type="number" />
        <Select
          onChange={(val) => formik.setFieldValue('storage_costs_unit', val)}
          options={unitsOptions}
          value={formik.values.storage_costs_unit}
          showSearch={false}
          fullWidth
          allowClear={false}
        />
      </OneLineControls>
    </FormGroup>
  )
}
